import { LoaderCircle } from "lucide-react";

function SpinnerMini() {
  return <LoaderCircle className="animate-spin" />;
}

export default SpinnerMini;
